import React from 'react';

import { Table } from '@/components/ui/table';
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationNext,
  PaginationPrevious
} from '@/components/ui/pagination';

import usePagination, { Options as UsePaginationOptions } from '@/hooks/usePagination';
import Loading from '../Loading';

export interface Props<K, T> extends Pick<UsePaginationOptions<K, T>, 'source'> {
  renderHeader: () => React.ComponentProps<'thead'> | null;
  children: (data: T[]) => React.ReactElement;
}

const PaginatedTable = <K, T>({ ...props }: React.PropsWithChildren<Props<K, T>>) => {
  const { renderHeader, children } = props;
  const { data, page, loading, totalNumberOfElements, totalNumberOfPages, loadPage, reload } = usePagination<T, K>(
    props
  );

  return (
    <div>
      <Table>
        {renderHeader()}

        {children(data)}
      </Table>

      <Loading visible={loading} />

      <div className="flex justify-center mt-4">
        <Pagination>
          <PaginationContent>
            <PaginationItem>
              <PaginationPrevious
                onClick={() => loadPage(page - 1)}
                className={page === 1 ? 'pointer-events-none opacity-50' : ''}
              />
            </PaginationItem>
            <PaginationItem>
              <span className="px-4 py-2 text-sm text-muted-foreground">
                page {page} of {totalNumberOfPages || 1} | total {totalNumberOfElements}
              </span>
            </PaginationItem>
            <PaginationItem>
              <PaginationNext
                onClick={() => loadPage(page + 1)}
                className={page >= totalNumberOfPages ? 'pointer-events-none opacity-50' : ''}
              />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      </div>
    </div>
  );
};

export default PaginatedTable;
